import { render, staticRenderFns } from "./Validate.vue?vue&type=template&id=4d80f3e4&scoped=true&"
import script from "./Validate.vue?vue&type=script&lang=js&"
export * from "./Validate.vue?vue&type=script&lang=js&"
import style0 from "./Validate.vue?vue&type=style&index=0&id=4d80f3e4&scoped=true&lang=scss&"
import style1 from "./Validate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d80f3e4",
  null
  
)

export default component.exports